import { render, staticRenderFns } from "./NewsGallerySection.vue?vue&type=template&id=c414c570&scoped=true&lang=pug"
import script from "./NewsGallerySection.vue?vue&type=script&lang=js"
export * from "./NewsGallerySection.vue?vue&type=script&lang=js"
import style0 from "./NewsGallerySection.styl?vue&type=style&index=0&id=c414c570&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c414c570",
  null
  
)

export default component.exports